import styled from "styled-components";

export const AllocationsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
